import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center app-page" role="status" aria-live="polite">
        <div className="text-center">
          <div className="auth-spinner !w-8 !h-8 !mb-3" aria-hidden="true" />
          <p className="app-brand-title text-sm font-semibold">Restoring your session…</p>
          <p className="app-subtle text-xs mt-1">Validating secure access</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;